/**
 * RESPONSIBILITY: the band at the bottom of every page.
 *
 * One address: where the church meets on Sunday. The property address that used to sit
 * beside it is gone — the site shows one place, not two.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link, List, RenderOf } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { FooterLink } from './rows/footer-link';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.Footer, label: 'Footer (every page)' })
export class FooterSection {
  @Text({
    label: 'Sunday worship label', maxLength: 120, default: 'Sunday worship',
    group: 'Where we are', description: 'The line above the first address.',
  })
  worshipLabel!: string;

  @Paragraph({
    label: 'Sunday worship address', rows: 3, markdown: true, allow: [],
    group: 'Where we are',
  })
  worshipAddress!: string;

  @RenderOf('worshipAddress')
  worshipAddressHtml!: string;


  @Text({ label: 'First button text', maxLength: 120, default: 'Plan a visit', group: 'Buttons' })
  visitLabel!: string;
  @Link({ label: 'First button link', group: 'Buttons', description: LINK_HINT })
  visitHref!: string;
  @Text({ label: 'Second button text', maxLength: 120, default: 'Contact us', group: 'Buttons' })
  contactLabel!: string;
  @Link({ label: 'Second button link', group: 'Buttons', description: LINK_HINT })
  contactHref!: string;

  @List({
    label: 'Link columns', of: () => FooterLink, maxItems: 40,
    description: 'Every link in the footer. Rows sharing a Column name sit under it.',
  })
  links!: FooterLink[];

  @List({
    label: 'Social links', of: () => FooterLink, maxItems: 8,
    description: 'The icons along the bottom.',
  })
  social!: FooterLink[];

  @Text({ label: 'Copyright', maxLength: 600, default: '© 2026 Austin Christian Fellowship of India' })
  copyright!: string;
}
